import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { advancedSearchResultFormSchema } from '../../../helpers/search/advancedSearchResultFormSchema';
import { fipRoute } from '../route';

export const fipClientSelectPageRoute = createRoute({
	path: '/client-select',
	getParentRoute: () => fipRoute,
	validateSearch: advancedSearchResultFormSchema,
	component: lazyRouteComponent(
		() => import('./FipClientSelectPage'),
		'FipClientSelectPage',
	),
});
